import styled from '@emotion/styled';

export const Container = styled.div`
  overflow: hidden;
  display: grid;
  height: 100%;
  min-width: var(--application-width-min);
  min-height: var(--application-height-min);
  grid-template-rows: min-content var(--header-height) 1fr;
  grid-template-columns: max-content 1fr;
  grid-template-areas:
    'warning-bar warning-bar'
    'navigation-bar header'
    'navigation-bar main';

  > nav {
    grid-area: navigation-bar;
  }

  > header {
    grid-area: header;
  }

  > main {
    display: flex;
    flex-direction: column;
    min-width: 0;
    min-height: 0;
  }
`;
